module.exports = require("dgram");


//////////////////
// WEBPACK FOOTER
// external "dgram"
// module id = 255
// module chunks = 0 1